import styled from 'styled-components';
import { SyncOutlined } from '@ant-design/icons';

export const RepeatingTaskIcon = styled(SyncOutlined)`
  font-size: 1.15em;
  color: ${({ theme }) => theme.contrastColor};
`;

export const CenteredSpan = styled.span`
  display: flex;
  justify-content: center;
`;
